import { ReactElement, SyntheticEvent, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import { RootState } from '../../../../redux/store'
import {
  FormWrapper,
  StyledButton,
  NoteWrapper,
  CardContainer,
  CardWrapper,
  CardBody
} from './subcomponents'
import strings from '../../../../locale/en'
import { Title } from '../subcomponents'
import { updateCourse } from '../../../../redux/register/action'
import { Loader } from '../../../../components'
import { useHistory } from 'react-router-dom'
import ROUTES from '../../../../const/routes'

const StudentPackage = (): ReactElement => {
  const { privateCourses, isLoading } = useSelector(
    (state: RootState) => ({
      privateCourses: state.register.privateCourses,
      isLoading: state.register.isLoading
    }),
    shallowEqual
  )
  const dispatch = useDispatch()
  const history = useHistory()
  const [isCourseSelected, setIsCourseSelected] = useState(false)

  const {
    register: {
      continueBtn,
      package: {
        student: { title, note }
      }
    }
  } = strings

  const handleClick = (coursesId: string) => {
    const updatedCourses = privateCourses.map((courses) =>
      courses.value === coursesId
        ? {
            ...courses,
            selected: !courses.selected
          }
        : courses
    )
    dispatch(updateCourse(updatedCourses))
    setIsCourseSelected(!isCourseSelected)
  }

  return (
    <FormWrapper
      onSubmit={(e: SyntheticEvent) => {
        e.preventDefault()
        history.push(ROUTES.PURCHASE_COURSE)
      }}
    >
      <Title>{title}</Title>
      <CardContainer>
        {isLoading ? (
          <Loader />
        ) : (
          privateCourses.map((course, index) => {
            const cardClassName = course.selected ? 'selected' : ''
            return (
              <CardWrapper
                className={cardClassName}
                onClick={() => handleClick(course.value)}
                key={`course-${index}`}
              >
                <CardBody>
                  {course.label}
                  {course.selected && (
                    <FontAwesomeIcon
                      className="selected"
                      icon={['fas', 'check-circle']}
                      size="1x"
                    />
                  )}
                </CardBody>
              </CardWrapper>
            )
          })
        )}
      </CardContainer>
      <NoteWrapper>
        <b>Note:</b> {note}
      </NoteWrapper>
      <StyledButton
        className="mb-3 mt-3"
        variant="primary"
        type="submit"
        disabled={!isCourseSelected}
      >
        {continueBtn}
      </StyledButton>
    </FormWrapper>
  )
}

export default StudentPackage
